
import React from 'react';
import JourneyMap from '@/components/JourneyMap';

const Index = () => {
  // The page title will be set by JourneyMap component itself
  return <JourneyMap />;
};

export default Index;
